import React from 'react'

export const Table = (props) => {
  return(
    <div className="table">
      {props.children}
    </div>
  )
}

export default Table
